import { NotificationManager } from "react-notifications";
import { all, fork, put, takeEvery } from "redux-saga/effects";
import TextConstants from "src/helpers/TextConstants";
import {
  LOGIN_USER,
  LOGOUT_USER,
  letLogoutUserSuccess,
  loginUserFailed,
  loginUserSuccess,
} from "../actions";

function* loginWithUsernamePassword({ payload }) {
  try {
    const { loginType, user } = payload;

    // make sure that users are logged into respected portal [Start]
    const { attributes, signInUserSession } = user;
    let userType;
    if (attributes && attributes.hasOwnProperty("custom:company_id")) {
      userType = "CA";
    } else if (
      attributes &&
      attributes.hasOwnProperty("custom:department_id")
    ) {
      if (loginType === "haccp") {
        userType = "DMHACCP";
      } else {
        userType = "DM";
      }
    } else if (attributes && attributes.hasOwnProperty("custom:store_id")) {
      userType = "GU";
    } else if (attributes && attributes["custom:role"]) {
      userType = "SETUP_ADMIN";
    } else {
      userType = "SA";
    }

    if (
      ["SA", "CA", "DM", "SETUP_ADMIN"].includes(userType) &&
      loginType === "haccp"
    ) {
      NotificationManager.error(
        TextConstants.PermissionDeniedMessage,
        "",
        5000
      );
      yield put(loginUserFailed());
      return false;
    }
    if (["DMHACCP", "GU"].includes(userType) && loginType === "management") {
      NotificationManager.error(
        TextConstants.PermissionDeniedMessage,
        "",
        5000
      );
      yield put(loginUserFailed());
      return false;
    }
    // make sure that users are logged into respected portal [End]

    const userToken = signInUserSession.idToken.jwtToken;
    const refreshToken = signInUserSession.refreshToken.token;

    if (userToken && refreshToken) {
      const haccp2BaseUrl = process.env.REACT_APP_HACCP2_URL;
      const encodedToken = encodeURIComponent(userToken);
      const encodedRfToken = encodeURIComponent(refreshToken);
      const redirectUrl = `${haccp2BaseUrl}ssoauth?loginType=${loginType}&token=${encodedToken}&refreshToken=${encodedRfToken}`;
      return window.location.replace(redirectUrl);
    }

    NotificationManager.error(TextConstants.InvalidCreds, "", 5000);
    yield put(loginUserFailed());
    return;

    const userData = { ...user, userType };

    const currentVersion = localStorage.getItem("_version");
    // clear the storage
    localStorage.clear();

    if (currentVersion) {
      localStorage.setItem("_version", currentVersion);
    }

    // check if already stored, than removed
    if (localStorage.getItem("HaccpAppUserData")) {
      localStorage.removeItem("HaccpAppUserData");
    }

    if (localStorage.getItem("userToken")) {
      localStorage.removeItem("userToken");
    }

    localStorage.setItem("HaccpAppUserData", JSON.stringify(userData));
    localStorage.setItem("userToken", userToken);
    yield put(loginUserSuccess({ data: userData, userType, loginType }));
  } catch (error) {
    console.log("login error : ", error);
    yield put(loginUserFailed());
  }
}

function* letLogoutUser() {
  try {
    // clear storage data
    localStorage.removeItem("HaccpAppUserData");
    localStorage.removeItem("userToken");
    localStorage.removeItem("BmList");
    localStorage.removeItem("SelectedBmId");
    localStorage.removeItem("SelectedStore");
    localStorage.removeItem("SensorListScrollTop");
    yield put(letLogoutUserSuccess());
  } catch (error) {
    console.log("login error : ", error);
  }
}

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, loginWithUsernamePassword);
  yield takeEvery(LOGOUT_USER, letLogoutUser);
}

export default function* rootSaga() {
  yield all([fork(watchLoginUser)]);
}
